import { Link } from 'react-router-dom';
import { Box, Flex, Text } from "@chakra-ui/react";
import SleepingMascotImage from './SleepingMascotImage';

export default function UnexpectedErrorPage() {

	return (
		<Box mt='2em' >
			<Flex direction="column" align="center" bg='white' rounded='1em' py='1em'>
				<Box fontSize='1.2em' fontWeight='600'>Oops, you're encountering an unexpected error!</Box>

				<Text mb='1em'>It's not you, this one's definitely on us. Sorry!</Text>
				<Text mt='0.2em'>Gnocco, our mischievous Chief Doggo Officer, may have something to do with it</Text>

				<Link to='/home'>
					<Box bg='gray.100' rounded='1em' px='1em' py='0.4em'>
						<Text>Back to Homepage</Text>
					</Box>
				</Link>
				<SleepingMascotImage />
			</Flex>
		</Box>
	)
}